
/* eslint-disable simple-import-sort/imports */
import Cookies from 'js-cookie'
import { mapGetters } from 'vuex'

import { unlocalizeRouteName } from '@marketplace/helpers/router.js'

import ModalPaymentDetails from '@marketplace/components/modals/modal-payment-details.vue'
import ModalBuyerProtection from '@marketplace/components/modals/modal-buyer-protection.vue'
import ModalCancelOrder from '@marketplace/components/modals/modal-cancel-order.vue'
import ModalEcomDetails from '@marketplace/components/modals/modal-ecom-details.vue'
import ModalFeedback from '@marketplace/components/modals/modal-feedback.vue'
import ModalGeneralSuccess from '@marketplace/components/modals/modal-general-success.vue'
import ModalImages from '@marketplace/components/modals/modal-images.vue'
import ModalInboxNewMessage from '@marketplace/components/modals/modal-inbox-new-message.vue'
import ModalLanguagePicker from '@marketplace/components/modals/modal-language-picker.vue'
import ModalLogin from '@marketplace/components/modals/modal-login.vue'
import ModalBnplCheckout from '@marketplace/components/modals/modal-bnpl-checkout.vue'
import ModalOrderDownloadImages from '@marketplace/components/modals/modal-order-download-images.vue'
import ModalOrderFeedbackDashboard from '@marketplace/components/modals/modal-order-feedback-dashboard.vue'
import ModalOrderIssue from '@marketplace/components/modals/modal-order-issue.vue'
import ModalOrderReorder from '@marketplace/components/modals/modal-order-reorder.vue'
import ModalVoucherExplained from '@marketplace/components/modals/modal-voucher-explained.vue'
import ModalVoucherPicker from '@marketplace/components/modals/modal-voucher-picker.vue'
import ModalVoucherPrompt from '@marketplace/components/modals/modal-voucher-prompt.vue'
import ModalTicaConnect from '@marketplace/components/modals/modal-tica-connect.vue'
import ModalOdfPromo from '@marketplace/components/modals/ModalOdfPromo.vue'
import ModalOrderProductDetails from '@marketplace/components/modals/modal-order-product-details.vue'
import ModalOrderShipmentDetails from '@marketplace/components/modals/modal-order-shipment-details.vue'
import ModalTrademartPartnership from '@marketplace/components/modals/marketplace/ModalTrademartPartnership.vue'
import ModalEducateUsers from '@marketplace/components/modals/modal-educate-users.vue'
import ModalWelcome from '@marketplace/components/modals/modal-welcome.vue'
import ModalHowOCWorks from '@marketplace/components/modals/modal-how-oc-works.vue'
import ModalReachCustomerService from '@marketplace/components/modals/modal-reach-customer-service.vue'
import ModalWholesaleTerms from '@marketplace/components/modals/modal-wholesale-terms.vue'
import ModalOrderViewIssue from '@marketplace/components/modals/modal-order-view-issue.vue'
import ModalWhyUseOC from '@marketplace/components/modals/modal-why-use-oc.vue'
import ModalPaymentMethods from '@marketplace/components/modals/modal-payment-methods.vue'
import ModalOrderProcess from '@marketplace/components/modals/modal-order-process.vue'
import ModalContent from '@marketplace/components/modals/modal-content.vue'
import ModalPrompt from '@marketplace/components/modals/modal-prompt.vue'
import ModalBuyOcPlus from '@marketplace/components/modals/ModalBuyOcPlus.vue'
import {
    TICA_CONNECT_MODAL_COOKIE_NAME,
    OC_ODF_COOKIE_NAME,
    OC_SHOW_WELCOME_MODALS_COOKIE_NAME,
} from '@marketplace/config/cookie.js'
import { TRIGGER_ODF_MODAL } from '@marketplace/config/modal.js'
import { OC_PLUS_MODAL_TRIGGER } from '@marketplace/config/ocplus.js'

import { EventBus } from '@marketplace/plugins/event-bus.js'
import { toggleBodyScroll } from '@marketplace/mixins/body.js'
import { isDateExpired, timeUntil } from '@marketplace/helpers/datetime.js'
import { trackModals } from '@marketplace/helpers/segment/index.js'
const ODF_PROMO_END_DATE = '2026-01-31'
const ODF_PROMO_COUNTRIES = ['NL', 'BE', 'DE', 'AT']

export default {
    name: 'TheModalWrapper',

    components: {
        ModalPaymentDetails,
        ModalBuyerProtection,
        ModalCancelOrder,
        ModalEcomDetails,
        ModalFeedback,

        ModalGeneralSuccess,
        ModalImages,
        ModalInboxNewMessage,
        ModalLanguagePicker,
        ModalLogin,
        ModalOrderDownloadImages,
        ModalOrderFeedbackDashboard,
        ModalOrderIssue,
        ModalOrderReorder,
        ModalVoucherExplained,
        ModalVoucherPicker,
        ModalVoucherPrompt,
        ModalTicaConnect,
        ModalOrderProductDetails,
        ModalOrderShipmentDetails,
        ModalBnplCheckout,
        ModalEducateUsers,
        ModalWelcome,
        ModalHowOCWorks,
        ModalReachCustomerService,
        ModalWholesaleTerms,
        ModalOrderViewIssue,
        ModalWhyUseOC,
        ModalPaymentMethods,
        ModalOrderProcess,
        ModalContent,
        ModalPrompt,
        ModalOdfPromo,
        ModalBuyOcPlus,
    },

    data() {
        return {
            visible: false,
            component: null,
            componentProps: null,
            shouldReloadOnClose: false,
            shouldClosingBeBlocked: false,
            unSeenVoucherModals: [],
            scrollX: 0,
            scrollY: 0,
            aModalAlreadyTriggered: false,
            lastVoucherStepSeen: false,
        }
    },

    computed: {
        ...mapGetters('global', [
            'hasPossibleTicaMatches',
            'hasTicaNumber',
            'userCountry',
            'hasOtherBNPLActive',
            'account',
            'getRelevantVoucher',
        ]),
        ...mapGetters('ocplus', ['canSeeOcPlus']),

        isOrderConfirmationPage() {
            return window.location.pathname.includes('/order')
        },

        showCloseButton() {
            if (this.shouldClosingBeBlocked) {
                return false
            }

            return !this.componentProps?.hideCloseButton
        },
        closeButtonText() {
            return this.componentProps?.closeButtonText || null
        },
        isRestrictedAccess() {
            return (
                this.$page.isSignupPage ||
                !this.$helpers.isLoggedIn ||
                this.isOrderConfirmationPage ||
                !this.$helpers.isRetailerAccount ||
                this.$page.isDropshippingPage
            )
        },
    },

    mounted() {
        EventBus.$on('modal-open', (componentName, props) => {
            if (this.$page.isSignupPage && !this.$page.isDsSignupPage) {
                return
            }

            this.openModal()
            this.componentProps = props
            this.setComponent(componentName)
        })

        EventBus.$on('lastVoucherStepReached', (isLastStepReached) => {
            this.lastVoucherStepSeen = isLastStepReached
        })

        EventBus.$on('triggerEducationModal', () => {
            if (this.isRestrictedAccess) {
                return false
            }

            setTimeout(() => {
                if (this.aModalAlreadyTriggered) {
                    return
                }

                this.aModalAlreadyTriggered = true

                this.trackModals('welcome')

                EventBus.$emit('modal-open', 'modal-welcome', {
                    closeButtonText: this.$t('labels.skip'),
                    voucherData: this.getRelevantVoucher,
                })
                Cookies.remove(OC_SHOW_WELCOME_MODALS_COOKIE_NAME)
            }, 1000)
        })

        EventBus.$on(TRIGGER_ODF_MODAL, () => {
            if (!this.canShowOdfPromo()) {
                return false
            }

            setTimeout(() => {
                if (!this.canShowOdfPromo() || this.aModalAlreadyTriggered) {
                    return
                }

                this.aModalAlreadyTriggered = true

                const expiresInDays = Math.max(
                    1,
                    timeUntil(ODF_PROMO_END_DATE, 'day') + 1
                )

                Cookies.set(OC_ODF_COOKIE_NAME, 1, {
                    expires: expiresInDays,
                })

                this.trackModals('odf')

                EventBus.$emit('modal-open', 'modal-odf-promo')
            }, 850)
        })

        EventBus.$on('modal-close', () => {
            this.closeModal()
            this.resetComponent()
        })

        EventBus.$on('modal-prevent-close', (payload) => {
            this.shouldClosingBeBlocked = payload
        })

        EventBus.$on('reset-modal-trigger-flag', () => {
            this.aModalAlreadyTriggered = false
        })

        EventBus.$on('modal-bnpl-checkout', (payload) => {
            trackModals('bnpl-checkout')

            EventBus.$emit('modal-open', 'modal-bnpl-checkout', payload)
        })

        // The voucher modal is only triggered via the welcome modal or TRademart welcome modals.
        EventBus.$on('triggerVoucherPromptModal', (voucher) => {
            if (!voucher || !voucher?.id || this.isRestrictedAccess) {
                return false
            }

            setTimeout(() => {
                if (this.aModalAlreadyTriggered) {
                    return
                }

                this.aModalAlreadyTriggered = true

                trackModals('voucherPrompt')

                // Set a cookie with the voucher type included
                Cookies.set(
                    `voucher--${voucher.id}`,
                    JSON.stringify({ used: 1, type: voucher.type }),
                    {
                        expires: 60,
                    }
                )

                EventBus.$emit('modal-open', 'modal-voucher-prompt', {
                    voucherData: { ...voucher },
                })
            }, 1200)
        })

        if (localStorage.getItem('ocShowPlusPaymentModal')) {
            localStorage.removeItem('ocShowPlusPaymentModal')
            if (this.isRestrictedAccess) {
                return
            }
            this.showBuyOcPlusModal(true)
        }

        EventBus.$on(OC_PLUS_MODAL_TRIGGER, (payload) => {
            if (this.isRestrictedAccess) {
                return
            }
            this.showBuyOcPlusModal()
            trackModals('OcPlusPayment')
        })

        const hash = window.location.hash
        if (
            hash.includes('#retailer-signup') ||
            hash.includes('#signup-modal')
        ) {
            this.$showSignupModal()
        }
        if (hash.includes('#login')) {
            if (window.Store?.accountId) {
                window.location.href = window.location.href.split('#')[0]
            } else {
                EventBus.$emit('modal-open', 'modal-login')
            }
        }

        this.checkForFollowBrandRoute()
        this.triggerTrademartPartnershipModal()
    },

    beforeDestroy() {
        EventBus.$off(OC_PLUS_MODAL_TRIGGER)
    },

    methods: {
        closeModal() {
            if (this.shouldClosingBeBlocked === false) {
                this.visible = false
                window.removeEventListener('keyup', this.handleEscape)
                if (this.shouldReloadOnClose) {
                    location.reload()
                }
            }

            toggleBodyScroll(false)
            window.scrollTo(this.scrollX, this.scrollY)

            if (this.component === 'modal-tica-connect') {
                this.handleTicaConnectModalClose()
            }

            if (this.component === 'modal-voucher-picker') {
                this.handleVoucherPickerClose()
            }

            if (this.component === 'modal-welcome') {
                this.handleVoucherModalOpen()
            }

            EventBus.$emit('modal-closed')

            this.aModalAlreadyTriggered = false
        },
        openModal() {
            this.$vfm.hideAll()
            this.visible = true
            this.scrollX = window.scrollX
            this.scrollY = window.scrollY
            toggleBodyScroll(true)
            window.scrollTo(this.scrollX, this.scrollY)
            window.addEventListener('keyup', this.handleEscape)
        },
        setComponent(component) {
            this.component = component
        },
        resetComponent() {
            this.component = null
            this.unSeenVoucherModals = []
        },
        handleEscape(e) {
            const key = e.which || e.keyCocde
            if (key === 27) {
                this.closeModal()
            }
        },
        handleVoucherPickerClose() {
            this.setModalCookie(`voucherPickerModalSeen`, 1, 4)
        },
        /**
         * Sets a cookie with the following arguments
         * expires is counted in days
         * maybe could be a global helper one day
         * @param {string} name
         * @param {string} value
         * @param {number} expires
         */
        setModalCookie(name, value, expires = 1) {
            Cookies.set(name, value, {
                expires,
            })
        },
        checkForFollowBrandRoute() {
            const routeParams = window.location.href
            if (
                routeParams.includes('follow-brand=true') &&
                !this.$helpers.isLoggedIn
            ) {
                Cookies.set('followBrand', 1, {
                    expires: 1,
                    path: routeParams,
                })
                EventBus.$emit('modal-open', 'modal-login')
            }
        },

        handleTicaConnectModalClose() {
            Cookies.set(TICA_CONNECT_MODAL_COOKIE_NAME, 1, {
                expires: 90,
            })
        },
        handleVoucherModalOpen() {
            if (this.componentProps?.voucherData) {
                if (!this.lastVoucherStepSeen) {
                    EventBus.$emit(
                        'triggerVoucherPromptModal',
                        this.componentProps?.voucherData
                    )
                } else {
                    trackModals('voucherPrompt')

                    // Reset the flag after handling
                    this.lastVoucherStepSeen = false
                }
            }
        },

        trackModals,

        showBuyOcPlusModal(checkPaymentStatus = false) {
            this.$vfm.show({
                component: ModalBuyOcPlus,
                bind: {
                    checkPaymentStatus,
                },
            })
        },
        canShowOdfPromo() {
            const country = (this.userCountry || '').toUpperCase()
            if (
                this.isRestrictedAccess ||
                !this.$page.isHomePage ||
                !ODF_PROMO_COUNTRIES.includes(country) ||
                Cookies.get(OC_ODF_COOKIE_NAME) ||
                isDateExpired(ODF_PROMO_END_DATE)
            ) {
                return false
            }

            return true
        },
        triggerTrademartPartnershipModal() {
            if (
                this.isRestrictedAccess ||
                !this.$page.isHomePage ||
                !this.$helpers.isLoggedIn
            ) {
                return
            }

            if (
                !this.$store.state.global.account
                    ?.shouldShowTrademartPartnershipModal
            ) {
                return
            }

            if (this.aModalAlreadyTriggered) {
                return
            }

            this.aModalAlreadyTriggered = true
            this.$vfm.show({
                component: ModalTrademartPartnership,
                bind: {
                    hideCloseButton: true,
                },
            })
        },
    },
}
